var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"lg":"6","offset-lg":"4"}},[_c('span',[_c('h2',[_vm._v("Sent Alerts")])])])],1),_c('vue-good-table',{attrs:{"columns":_vm.columns,"rows":_vm.rows,"groupOptions":{
               enabled: false,
              headerPosition: 'top'
              },"sort-options":{
                  enabled: true,
                  collapsable: true
              },"defaultSortBy":{field: 'status', type: 'certificationDate'},"styleClass":"vgt-table condensed table-bordered table-striped","pagination-options":{
                  enabled: true,
                  mode: 'records',
                  perPage: 50,
                  position: 'top',
                  perPageDropdown: [50, 100, 200],
                  dropdownAllowAll: false,
                  setCurrentPage: 1,
                  nextLabel: 'next',
                  prevLabel: 'prev',
                  rowsPerPageLabel: 'Rows per page',
                  ofLabel: 'of',
                  pageLabel: 'page', // for 'pages' mode
                  allLabel: 'All',
              }},scopedSlots:_vm._u([{key:"table-row",fn:function(props){return [(props.column.label === 'View')?_c('span',[_c('b-button',{attrs:{"size":"sm"},on:{"click":function($event){return _vm.goToAccountRequest(props.formattedRow[props.column.field],
                            props.formattedRow['entityType'])}}},[_vm._v("\n                          View\n              ")])],1):_c('span',[_vm._v("\n                      "+_vm._s(props.formattedRow[props.column.field])+"\n              ")])]}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }